import type { QuoteStatus } from '@/lib/database.types';

const LABELS: Record<QuoteStatus, { text: string; cls: string }> = {
  pendiente:      { text: 'PENDIENTE',     cls: 'bg-yellow-500/15 text-yellow-300 border border-yellow-500/30' },
  en_negociacion: { text: 'EN NEGOCIACIÓN', cls: 'bg-blue-500/15  text-blue-300  border border-blue-500/30' },
  aceptada:       { text: 'ACEPTADA',       cls: 'bg-green-500/15 text-green-300 border border-green-500/30' },
  rechazada:      { text: 'RECHAZADA',      cls: 'bg-red-500/15   text-red-300   border border-red-500/30' },
};

export function QuoteStatusBadge({ status }: { status: QuoteStatus }) {
  const s = LABELS[status];
  return (
    <span className={`badge-pill ${s.cls}`}>{s.text}</span>
  );
}
